import { MutableRefObject, useEffect, useRef, useState } from "react";

interface Dimensions {
    width: number;
    height: number;
}

const useResizeObserver = <T extends HTMLElement>(ref?: T): [MutableRefObject<T>, Dimensions] => {
    const containerRef = useRef<T>(ref);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const updateDimensions = () => {
            setDimensions({
                width: container.getBoundingClientRect()?.width,
                height: container.getBoundingClientRect()?.height
            });
        };

        updateDimensions();

        const resizeObserver = new ResizeObserver(updateDimensions);
        resizeObserver.observe(container);

        return () => {
            resizeObserver.disconnect();
        };
    }, []);


    return [containerRef, dimensions];
};

export default useResizeObserver;